<template>
  <div class="WizardInfo" ref="formName" data-name="wizard">
    <h3 class="FormRow-labelRadio">Vos coordonnées</h3>

    <div class="FormRow">
      <!-- prefix -->
      <form-wrapper :validator="$v.formValidations">
        <form-group name="prefix">
          <div class="FormRow-input Form-col2 Form-inputRadio">
            <div class="Form-inputRadioInner">
              <input
                type="radio"
                id="prefix-monsieur"
                name="prefix"
                value="Monsieur"
                required
                v-model.trim="formValidations.prefix"
                @input="$v.formValidations.prefix.$touch()"
                @change="setDataRequired('prefix')"
              />
              <label for="prefix-monsieur">Monsieur</label>
              <input
                type="radio"
                id="prefix-madame"
                name="prefix"
                value="Madame"
                required
                v-model.trim="formValidations.prefix"
                @input="$v.formValidations.prefix.$touch()"
                @change="setDataRequired('prefix')"
              />
              <label for="prefix-madame">Madame</label>
            </div>
          </div>
        </form-group>
      </form-wrapper>
    </div>

    <div class="FormRow FormRow-2col">
      <!-- LastName -->
      <form-wrapper :validator="$v.formValidations">
        <form-group name="lastname" class="long-error">
          <div
            class="FormRow-input Form-inputText"
            :class="{ validate: !$v.formValidations.lastname.$invalid && $v.formValidations.lastname.$dirty }"
          >
            <input
              type="text"
              id="lastname"
              name="lastname"
              class="topLabel"
              required
              v-model.trim="formValidations.lastname"
              @input="$v.formValidations.lastname.$touch()"
              @change="setDataRequired('lastname')"
            />
            <label for="lastname">Nom*</label>
          </div>
        </form-group>
      </form-wrapper>

      <!-- FirstName -->
      <form-wrapper :validator="$v.formValidations">
        <form-group name="firstname" class="long-error">
          <div
            class="FormRow-input Form-inputText"
            :class="{ validate: !$v.formValidations.firstname.$invalid && $v.formValidations.firstname.$dirty }"
          >
            <input
              type="text"
              id="firstname"
              name="firstname"
              class="topLabel"
              required
              @input="$v.formValidations.firstname.$touch()"
              v-model.trim="formValidations.firstname"
              @change="setDataRequired('firstname')"
            />
            <label for="firstname">Prénom*</label>
          </div>
        </form-group>
      </form-wrapper>
    </div>

    <div
      class="FormRow FormRow-2col"
    >
      <!-- Email -->
      <form-wrapper :validator="$v.formValidations" class="flex-col">
        <form-group name="email">
          <div
            class="FormRow-input Form-inputText"
            :class="{ validate: !$v.formValidations.email.$invalid && $v.formValidations.email.$dirty && !(accountExist && isCurrentUserIsLoggedIn === false), error: accountExist && isCurrentUserIsLoggedIn === false}"
          >
            <input
              type="email"
              name="email"
              id="email"
              class="topLabel"
              required
              v-model.trim="formValidations.email"
              @input="checkEmailValidity"
              @change="setDataRequired('email')"
            />
            <label for="email">Email*</label>
          </div>
        </form-group>

        <div class="WizardInfo-connect" v-if="accountExist && isCurrentUserIsLoggedIn === false">
          <p>
            Il semble que vous ayez déjà un compte 
            <template v-if="isZeborne"> ZEborne</template>
            <template v-else> Mon chauffagiste privé</template>
          </p>
          <p><button @click.prevent="openModal">connectez-vous</button> à votre compte</p>
        </div>
      </form-wrapper>
     
      <!-- Phone -->
      <form-wrapper :validator="$v.formValidations">
        <form-group name="phone" class="long-error">
          <div
            class="FormRow-input Form-inputText"
            :class="{ validate: !$v.formValidations.phone.$invalid && $v.formValidations.phone.$dirty }"
          >
            <input
              type="text"
              id="phone"
              name="phone"
              class="topLabel"
              maxlength="10"
              v-model.trim="formValidations.phone"
              @input="$v.formValidations.phone.$touch()"
              required
              @change="setDataRequired('phone')"
            />
            <label for="phone">Téléphone*</label>
          </div>
        </form-group>
      </form-wrapper>
    </div>

    <div class="FormRow">
      <!-- Adresse -->
      <form-wrapper :validator="$v.formValidations">
        <form-group name="adresse">
          <div
            class="FormRow-input Form-inputText full-width"
            :class="{ validate: !$v.formValidations.adresse.$invalid && $v.formValidations.adresse.$dirty }"
          >
            <input
                type="text"
                id="adresse"
                name="adresse"
                class="topLabel"
                v-model.trim="formValidations.adresse"
                @input="$v.formValidations.adresse.$touch()"
                required
                @change="setDataRequired('adresse')"
            />
            <label for="adresse">Adresse*</label>
          </div>
        </form-group>
      </form-wrapper>
    </div>

    <div class="FormRow Form-rowMobile FormRow-2col">
      <!-- City -->
      <form-wrapper :validator="$v.formValidations" class="FormRow Form-rowMobile-70">
        <form-group name="city">
          <div
            class="FormRow-input Form-inputText"
            :class="{ validate: !$v.formValidations.city.$invalid && $v.formValidations.city.$dirty }"
          >
            <input
              type="text"
              id="city"
              class="topLabel"
              name="city"
              v-model.trim="formValidations.city"
              required
              @input="$v.formValidations.city.$touch()"
              @change="setDataRequired('city')"
            />
            <label for="city">Ville*</label>
          </div>
        </form-group>
      </form-wrapper>
      <!-- PostalCode -->
      <form-wrapper :validator="$v.formValidations" class="FormRow Form-rowMobile-30">
        <form-group name="postalcode">
          <div class="FormRow-input Form-inputText">
            <input
              type="number"
              id="postalcode"
              name="postalcode"
              @keydown="preventPostalCodeMaxLength($event)"
              class="topLabel"
              v-model.trim="formValidations.postalcode"
              maxlength="5"
              disabled
              @input="$v.formValidations.postalcode.$touch()"
              @change="setDataRequired('postalcode')"
            />
            <label for="postalcode">Code postal*</label>
          </div>
        </form-group>
      </form-wrapper>
    </div>

    <div class="FormRow FormRow-2col">
      <!-- Is professional -->
      <form-wrapper :validator="$v.formValidations">
        <form-group name="isPro">
          <div class="FormRow-input Form-col2 Form-inputRadio">
            <span class="FormRow-labelRadio">Je suis un professionnel*</span>
            <div class="Form-inputRadioInner">
              <input
                type="radio"
                id="yes-pro"
                name="isPro"
                value="yes"
                required
                @change="displayCompany"
                v-model.trim="formValidations.isPro"
                @input="$v.formValidations.isPro.$touch()"
              />
              <label for="yes-pro">Oui</label>
              <input
                type="radio"
                id="no-pro"
                name="isPro"
                value="no"
                required
                @change="displayCompany"
                v-model.trim="formValidations.isPro"
                @input="$v.formValidations.isPro.$touch()"
              />
              <label for="no-pro">Non</label>
            </div>
          </div>
        </form-group>
      </form-wrapper>
    </div>

    <!-- Company -->
    <transition v-if="formValidations.isPro === 'yes'" name="slide-fade">
      <div class="FormRow">
        <form-wrapper :validator="$v.formValidations">
          <form-group name="company">
            <div
              class="FormRow-input Form-inputText"
              :class="{ validate: !$v.formValidations.company.$invalid && $v.formValidations.company.$dirty }"
            >
              <input
                type="text"
                id="company"
                name="company"
                class="topLabel"
                required
                v-model.trim="formValidations.company"
                @input="$v.formValidations.company.$touch()"
                @change="setDataRequired('company')"
              />
              <label for="company">Nom de la société</label>
            </div>
          </form-group>
        </form-wrapper>
      </div>
    </transition>

    <div class="FormRow FormColumn">
      <div class="FormRow-input Form-inputCheckbox">
        <input
          type="checkbox"
          id="comment_info-toggler"
          name="commentInfo"
          v-model="formValidations.commentInfo"
          @change="changeOptionalData('commentInfo', formValidations.commentInfo)"
        />
        <label for="comment_info-toggler">Ajouter des précisions à ma demande</label>
      </div>
    </div>
    <transition name="slide-fade">
      <div v-if="formValidations.commentInfo" class="FormRow FormColumn">
        <!-- Comment -->
        <div class="FormRow-input Form-inputTextarea">
          <label for="comment_info" class="FormRow-labelTextArea"
            >Ajouter des précisions à ma demande
          </label>

          <textarea
            id="comment_info"
            name="comment_info"
            v-model="formValidations.comment"
            @change="changeOptionalData('comment_info', formValidations.comment)"
            @keyup="calculateRemainsSpace(formValidations.comment)"
            rows="8"
            maxlength="500"
            placeholder="Pour aider votre technicien à préparer votre intervention, laissez-nous un commentaire."
          ></textarea>

          <span class="FormRow-info" v-if="maxLengthRemain === 500"
            >{{ maxLengthRemain }} caractères max</span
          >
          <span class="FormRow-info" v-else>{{ maxLengthRemain }} caractères restants</span>
        </div>
      </div>
    </transition>

    <div class="FormSeparator"></div>

    <form-wrapper :validator="$v.formValidations">
      <form-group name="proxiserve_optin">
        <div class="FormRow FormRowCgv">
          <!-- Optin -->
          <div class="FormRow-input Form-inputCheckbox">
            <input
              type="checkbox"
              id="proxiserve_optin"
              name="proxiserve_optin"
              v-model="formValidations.proxiserve_optin"
              @click="$v.formValidations.proxiserve_optin.$touch()"
              @change="changeOptionalData('proxiserve_optin', formValidations.proxiserve_optin)"
            />
            <label for="proxiserve_optin">
              <span>{{ legals }}</span>
            </label>
          </div>
        </div>
      </form-group>
    </form-wrapper>

    <transition name="slide-fade">
      <div class="CartRecap-submit">
        <ProgressButton
          :order="false"
          :hiddenButton="false"
          :next="getWizardStrapiFormId ? true : false"
          @next-step="$emit('next-step')"
          @checkout="$emit('checkout')"
          @progressButtonClicked="displayAllMissingRequired"
        ></ProgressButton>
      </div>
    </transition>

    <div class="CartRecap-CGV">
      <p>
        En finalisant votre commande vous acceptez les
        <a :href="cartCgv" target="_blank">Conditions Générales d’Utilisation*</a>
      </p>
      <p v-if="recaptchaEnabled">
        Ce site est protégé par reCAPTCHA et la
        <a href="https://policies.google.com/privacy" target="_blank">Politique de confidentialité</a> et les
        <a href="https://policies.google.com/terms" target="_blank">Conditions d'utilisation</a> de Google s'appliquent.
      </p>
    </div>

    <transition name="slide-fade">
      <ModalLogin
        :showModal="showModal"
        v-if="showModal"
        :class="'Modal-right'"
        @LoginModal::close="closeModal"
        :emailProps="formValidations.email"
        :shouldReload="false"
      ></ModalLogin>
    </transition>
  </div>
</template>

<script>
import TopLabelMixin from "@/mixins/topLabelMixin";
import verifyAccountMixin from "@/mixins/actions/account/verifyAccountMixin";
import formValidationMixin from "@/mixins/actions/validation/formValidationMixin";
import { mapGetters, mapActions } from "vuex";
import ModalLogin from "@/components/Modal/ModalLogin.vue";
import ProgressButton from "@/components/ProgressButton/ProgressButton.vue";

import { preventPostalCodeMaxLength } from "@/services/validations.js";

import GoogleAutocomplete from "@/components/Autocomplete/GoogleAutocomplete";

import "@/components/Wizard/WizardInfo/WizardInfo.scss";

export default {
  name: "WizardInfo",
  mixins: [TopLabelMixin, verifyAccountMixin, formValidationMixin],

  components: {
    ModalLogin,
    ProgressButton,
    GoogleAutocomplete,
  },

  data() {
    return {
      maxLengthRemain: 500,
      asBeenFilled: false,
      showModal: false,
      companyDisplay: false,
      recaptchaEnabled: window.recaptchaSiteKey ? true : false,
    };
  },

  computed: {
    ...mapGetters({ wizardInfo: "getWizardInfoRequired" }),
    ...mapGetters({ getWizardInfoPostalCode: "getWizardInfoPostalCode" }),
    ...mapGetters({ isCurrentUserIsLoggedIn: "isCurrentUserIsLoggedIn" }),
    ...mapGetters({ currentUserInfo: "getCurrentUserInfo" }),
    ...mapGetters({ currentUserShippingInfo: "getCurrentUserShippingInfo" }),
    ...mapGetters({ cartCgv: "getCurrentCartCGV"}),
    ...mapGetters({isZeborne: "isZeborne"}),
    ...mapGetters({ getWizardStrapiFormId: "getWizardStrapiFormId" }),
    ...mapGetters({ storeId: "getStoreId" }),
    legals() {
      let label = `J’accepte que le groupe Proxiserve utilise mes données personnelles, pour environ 2
                fois par an pour me proposer des communications sur les prestations demandées et les
                prestations associées;`;
      if (this.storeId === 2) {
        label = `J'accepte que le groupe Proxiserve et sa marque ZEborne utilise mes données personnelles
        pour les prestations demandées et les services associés.`;
      }
      return label;
    }
  },


  watch: {
    isCurrentUserIsLoggedIn() {
      this.fillInputWithValue();
    },
    getWizardInfoPostalCode() {
      this.formValidations.postalcode = this.getWizardInfoPostalCode;
      this.formFillProgress(this.wizardInfo);
    },
  },

  methods: {
    ...mapActions(["addRequiredCompanyToStore", "removeRequiredCompanyToStore"]),

    calculateRemainsSpace(data) {
      this.maxLengthRemain = 500 - data.length;
    },

    displayCompany(event) {
      if (event.target.value === "yes") {
        this.companyDisplay = true;
        this.addRequiredCompanyToStore();
      } else {
        this.companyDisplay = false;
        this.removeRequiredCompanyToStore();
      }
      this.setDataRequired(event.target.name);
    },


    changeOptionalData(name, data) {
      this.$store.dispatch("setWizardInfoOptional", {
        data,
        type: name,
      });
    },

    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },

    getAddressData(val) {
      this.formValidations.city = val.locality;
      this.formValidations.adresse = `${val.street_number ? val.street_number : ""} ${val.route}`;
    },


    handleAddress(address) {
      this.formValidations.adresse = typeof address === 'object' ? address.newVal : address;
    },

    preventPostalCodeMaxLength,
  },
};
</script>
